import React, { ReactNode } from "react";
import { NavigationBarProps } from "./NavigationBar";

import SafeArea from "@/components/safe-area";
import CoverContainer from "./CoverContainer";
import NavigationBarContainerSkeleton from "./skeletons/NavigationBarContainerSkeleton";
import clsx from "clsx";
import dynamic from "next/dynamic";

const Navigation = dynamic(() => import("./Navigation"));

interface Props {
	navigation: NavigationBarProps;
	footer?: ReactNode;
	children: ReactNode;
	showNavigationBar?: boolean;
	showSkeleton?: boolean;
	skeleton?: ReactNode;
	className?: string;
	style?: React.CSSProperties;
	hiddenSafeArea?: boolean;
}

/**
 * 有导航的最外层容器
 */
const NavigationContainer: React.FC<Props> = ({
	navigation,
	footer,
	children,
	showNavigationBar = true,
	showSkeleton,
	skeleton,
	className,
	style,
	hiddenSafeArea,
}) => {
	const renderSkeleton = () => {
		if (!showSkeleton) return null;
		return skeleton ? skeleton : <NavigationBarContainerSkeleton showNavigationBar={showSkeleton} />;
	};

	return (
		<CoverContainer>
			<div
				className={clsx("navigation--wrapper relative z-10 flex w-full flex-col max-w-screen-sm mx-auto", className)}
				style={style}
			>
				<div className="flex-shrink-0">{showNavigationBar && <Navigation {...navigation} />}</div>

				<div className="flex-1 overflow-y-auto hidden-scroll-bar scroll-smooth">{children}</div>

				<div className="flex-shrink-0">
					{footer}
					{!hiddenSafeArea && <SafeArea position="bottom" />}
				</div>

				{renderSkeleton()}
			</div>
		</CoverContainer>
	);
};

NavigationContainer.displayName = "NavigationContainer";
export default NavigationContainer;
